var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvelopeFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 15,
    viewBox: "0 0 19 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.85999 7.20996L0.690002 2.12012C1.48 0.850117 2.9 0 4.5 0H14.5C16.1 0 17.51 0.840107 18.31 2.11011L11.16 7.18994C10.15 7.85994 8.84999 7.85996 7.85999 7.20996ZM18.98 4.1001L12.3 8.84009C11.44 9.41009 10.46 9.68994 9.48999 9.68994C8.52999 9.68994 7.56998 9.4101 6.72998 8.8501L0.0200195 4.1001C0.0100195 4.2301 0 4.37 0 4.5V10.5C0 12.98 2.02 15 4.5 15H14.5C16.98 15 19 12.98 19 10.5V4.5C19 4.37 18.99 4.2301 18.98 4.1001Z",
    fill: "url(#paint0_linear_1_328)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_328",
    x1: 20.8657,
    y1: -1.03916,
    x2: -2.59158,
    y2: 5.10367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0794952,
    stopColor: "#55A7CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.970165,
    stopColor: "#1F617D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeFilled);
export default __webpack_public_path__ + "static/media/envelope-Filled.fa44bd48a271cf3917c417ef0f210176.svg";
export { ForwardRef as ReactComponent };